var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.398,
    height: 16.4,
    viewBox: "0 0 12.398 16.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5972",
    "data-name": "Group 5972",
    transform: "translate(-14674.918 -21737.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-favourite-1276079",
    transform: "translate(14675.068 21738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5948",
    "data-name": "Path 5948",
    d: "M187.6,88.757l6.049-4.36,6.049,4.36V72.8H187.6Zm.417-15.54h11.264V87.923l-5.632-4.047-5.632,4.047Z",
    transform: "translate(-187.6 -72.8)",
    fill: "#333",
    stroke: "#333",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5949",
    "data-name": "Path 5949",
    d: "M271.752,165.809l1.335.709a.481.481,0,0,0,.5-.042.493.493,0,0,0,.188-.459l-.25-1.5c0-.021,0-.042.021-.042l1.085-1.064a.509.509,0,0,0,.125-.48.478.478,0,0,0-.375-.313l-1.5-.209a.073.073,0,0,1-.042-.021l-.688-1.4a.456.456,0,0,0-.834,0l-.668,1.356c0,.021-.021.021-.042.021l-1.5.209a.425.425,0,0,0-.375.313.462.462,0,0,0,.125.48l1.085,1.064c.021.021.021.021.021.042l-.25,1.5a.427.427,0,0,0,.146.5.459.459,0,0,0,.271.083.475.475,0,0,0,.229-.063l1.335-.709c.042.021.042.021.062.021Zm-.25-.375-1.335.709c-.021.021-.042,0-.063,0s-.021-.021-.021-.063l.25-1.5a.458.458,0,0,0-.146-.417L269.1,163.1a.077.077,0,0,1-.021-.063.045.045,0,0,1,.042-.042l1.5-.209a.5.5,0,0,0,.355-.25l.668-1.356a.065.065,0,0,1,.042-.021s.042,0,.042.021l.668,1.356a.446.446,0,0,0,.355.25l1.5.209a.045.045,0,0,1,.042.042.077.077,0,0,1-.021.063l-1.085,1.064a.518.518,0,0,0-.146.417l.25,1.5a.077.077,0,0,1-.021.063c-.021,0-.042.021-.063,0l-1.335-.709a.39.39,0,0,0-.376,0Z",
    transform: "translate(-265.682 -157.444)",
    fill: "#333",
    stroke: "#333",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.327045eac91e0b55d63e62353dc6abc1.svg";
export { ForwardRef as ReactComponent };